module.exports = __webpack_public_path__ + "static/img/13.d120835.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/2/sp/13.png
// module id = ylka
// module chunks = 0